import React, { useEffect, useState } from "react";
import "./hydrafacial.css";
import { useNavigate, Link, useLocation } from "react-router-dom";
import heroImage from "../../../assets/images/ad-warts.jpg";
import heroImage1 from "../../../assets/images/ad-warts1.jpg";
import favicon from "../../../assets/images/favicon.ico";

import deepCleansingIcon from "../../../assets/images/deep-cleansing.png";
import enhancedHydrationIcon from "../../../assets/images/enhanced-hydration.png";
import skinRenewalIcon from "../../../assets/images/skin-renewal.png";
import nonInvasiveIcon from "../../../assets/images/non-invasive.png";

// Import PNG icons for navigation treatments
import hydrafacialIcon from "../../../assets/images/botox.png";
import acneIcon from "../../../assets/images/navacne.png";
import skinBrighteningIcon from "../../../assets/images/skin-brightening.png";
import antiAgeingIcon from "../../../assets/images/anti-ageing.png";
import youthIcon from "../../../assets/images/youth.png";
import prpFaceIcon from "../../../assets/images/prpface.png";
import co2FacialIcon from "../../../assets/images/co2.png";
import acneScarIcon from "../../../assets/images/acnescar.png";
import moleBirthMarkIcon from "../../../assets/images/wart.png";
import tattoRemovalIcon from "../../../assets/images/tattoo.png";
import wartsRemovalIcon from "../../../assets/images/blackhead.png";
import antiAgeingLaserIcon from "../../../assets/images/laser.png";
import laserHairRemovalIcon from "../../../assets/images/laserHairRemoval.png";

const treatments = [
  { name: "ADVANCED HYDRAFACIAL" },
  { name: "ACNE" },
  { name: "ANTI AGEING" },
  { name: "YOUTH" },
  { name: "PRP FACE" },
  { name: "CO2 FACIAL" },
  { name: "ACNE SCAR" },
  { name: "MOLE & BIRTH MARK REMOVAL" },
  { name: "SKIN BRIGHTENING" },
  { name: "TATTO REMOVAL" },
  { name: "WARTS REMOVAL" },
  { name: "ANTI AGEING LASER" },
  { name: "LASER HAIR REMOVAL" },
];

// Mapping treatment names to their PNG icons
const treatmentIconPNGMap = {
  "ADVANCED HYDRAFACIAL": hydrafacialIcon,
  ACNE: acneIcon,
  "SKIN BRIGHTENING": skinBrighteningIcon,
  "ANTI AGEING": antiAgeingIcon,
  YOUTH: youthIcon,
  "PRP FACE": prpFaceIcon,
  "CO2 FACIAL": co2FacialIcon,
  "ACNE SCAR": acneScarIcon,
  "MOLE & BIRTH MARK REMOVAL": moleBirthMarkIcon,
  "TATTO REMOVAL": tattoRemovalIcon,
  "WARTS REMOVAL": wartsRemovalIcon,
  "ANTI AGEING LASER": antiAgeingLaserIcon,
  "LASER HAIR REMOVAL": laserHairRemovalIcon,
};

// Mapping treatment names to their URLs with "advanced" prefix
const treatmentUrlMap = {
  "ADVANCED HYDRAFACIAL": "/advanced-hydrafacial-treatment",
  "ACNE": "/advanced-acne-treatment",
  "ANTI AGEING": "/advanced-anti-ageing-treatment",
  "YOUTH": "/advanced-youth-treatment",
  "PRP FACE": "/advanced-prp-face-treatment",
  "CO2 FACIAL": "/advanced-co2-facial-treatment",
  "ACNE SCAR": "/advanced-acne-scar-treatment",
  "MOLE & BIRTH MARK REMOVAL": "/advanced-mole-birth-mark-removal-treatment",
  "SKIN BRIGHTENING": "/advanced-skin-brightening-treatment",
  "TATTO REMOVAL": "/advanced-tatto-removal-treatment",
  "WARTS REMOVAL": "/advanced-warts-removal-treatment",
  "ANTI AGEING LASER": "/advanced-anti-ageing-laser-treatment",
  "LASER HAIR REMOVAL": "/advanced-laser-hair-removal-treatment",
};

// Define the gallery images
const images = [
  { src: "https://images.unsplash.com/photo-1560750588-73207b1ef5b8?q=80", alt: "Before and After Warts Removal Results" },
  { src: "https://images.unsplash.com/photo-1609840114035-3c981b782dfe?q=80", alt: "Warts Removal Procedure Close-Up" },
  { src: "https://images.unsplash.com/photo-1606206522398-de3bd05b1615?q=80", alt: "Advanced Warts Removal Equipment" },
];

function TreatmentNav() {
  const [activeTab, setActiveTab] = useState("WARTS REMOVAL");
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const pathSegments = location.pathname.split("/");
    const treatmentPath = pathSegments[pathSegments.length - 1];
    
    const currentTreatment = Object.entries(treatmentUrlMap).find(
      ([name, url]) => url.includes(treatmentPath)
    );
    
    if (currentTreatment) {
      setActiveTab(currentTreatment[0]);
    }
  }, [location.pathname]);

  const renderTreatmentIcon = (name) => {
    return treatmentIconPNGMap[name] ? (
      <img
        src={treatmentIconPNGMap[name]}
        alt={name}
        style={{ width: "100px", height: "100px" }}
      />
    ) : null;
  };

  const handleCardClick = (name) => {
    setActiveTab(name);
    navigate(treatmentUrlMap[name]);
  };

  return (
    <div className="ads-treatment-nav-container">
      <h2>Innovative Warts Removal Solutions</h2>
      <div className="ads-treatment-nav-cards">
        {treatments.map(({ name }) => (
          <div
            key={name}
            className={`ads-treatment-nav-card ${activeTab === name ? "active" : ""}`}
            onClick={() => handleCardClick(name)}
          >
            <div className="ads-card-icon">
              {renderTreatmentIcon(name)}
            </div>
            <div className="ads-card-title">{name}</div>
          </div>
        ))}
      </div>
    </div>
  );
}

function Wartsremoval() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalImage, setModalImage] = useState(null);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [visibleGalleryImages, setVisibleGalleryImages] = useState([0, 1, 2]);
  
  // SEO optimization for Warts Removal page
  useEffect(() => {
    // Enhanced SEO title with specific location keywords
    document.title =
      "Best Warts Removal Treatment in Chennai, Bangalore | Painless Warts Removal Tamil Nadu Karnataka - H-Cura Multispecialty";
    
    const metaDescription = document.querySelector("meta[name='description']");
    if (metaDescription) {
      metaDescription.setAttribute(
        "content",
        "Discover the best warts removal treatment in Chennai, Bangalore at H-Cura. Our advanced medical techniques provide safe, effective, and painless solutions for common warts, plantar warts, genital warts, and flat warts with minimal scarring. Professional dermatological services available across Tamil Nadu, Karnataka, and Pondicherry."
      );
    }
    
    const metaKeywords = document.querySelector("meta[name='keywords']");
    if (metaKeywords) {
      metaKeywords.setAttribute(
        "content",
        "warts removal Chennai, warts removal Bangalore, warts removal clinic Tamil Nadu, dermatologist Karnataka, common warts treatment Chennai Bangalore, plantar warts removal specialist Tamil Nadu Karnataka, best warts removal clinic Chennai Bangalore, warts removal near me, genital warts treatment Tambaram Valasaravakkam Gerugambakkam Jayanagar, dermatology clinic Chennai Bangalore, flat warts removal Tamil Nadu Karnataka, cryotherapy for warts Chennai Bangalore, laser warts treatment specialist Chromepet Pallavaram Perungalathur Koramangala BTM Layout JP Nagar, advanced warts removal Porur Alwarthirunagar Virugambakkam Banashankari Basavanagudi, electrocautery warts removal Kundrathur Mangadu Poonamallee Wilson Garden Lalbagh, painless warts treatment Chennai Bangalore, HPV warts treatment Tamil Nadu Karnataka, medical warts removal Chennai Bangalore, skin warts solutions Tamil Nadu Karnataka, warts elimination clinic Tambaram Jayanagar, warts treatment specialists Valasaravakkam Koramangala, facial warts removal Gerugambakkam BTM Layout, hand warts treatment Chennai Bangalore, foot warts removal Tamil Nadu Karnataka, non surgical warts removal Chennai Bangalore, warts treatment for children Tamil Nadu Karnataka, warts prevention Chennai Bangalore, warts consultation Chennai Bangalore, warts skin analysis Tamil Nadu Karnataka, warts treatment prevention Chennai Bangalore, warts skin health Tamil Nadu Karnataka, dermatological warts removal treatment Chennai Bangalore, cosmetic warts removal dermatology Tamil Nadu Karnataka, medical warts removal skincare Chennai Bangalore, professional warts removal treatment Tamil Nadu Karnataka, warts removal skin wellness Chennai Bangalore, warts removal dermatology services Tamil Nadu Karnataka, warts removal treatment Tambaram Gandhi Road Jayanagar, warts removal clinic Valasaravakkam Krishnamachari Nagar Koramangala, warts removal dermatologist Gerugambakkam Ramachandra Nagar BTM Layout, warts removal doctor Chromepet Pallavaram JP Nagar Banashankari, warts removal skin treatment Porur Alwarthirunagar Basavanagudi Wilson Garden, warts removal treatment clinic Virugambakkam Kundrathur Lalbagh, warts removal rejuvenation treatment Mangadu Poonamallee Bangalore"
      );
    }

    // Add structured data for local business with specific locations
    const structuredData = {
      "@context": "https://schema.org",
      "@type": "MedicalBusiness",
      "name": "H-Cura Multispeciality Clinic",
      "description": "Advanced warts removal and skin lesion treatment clinic offering professional dermatological services across Chennai Tamil Nadu, Bangalore Karnataka, and Pondicherry",
      "url": "https://www.h-cura.com/advanced-warts-removal-treatment",
      "telephone": "+91 88700 01377",
      "priceRange": "₹₹",
      "address": [
        {
          "@type": "PostalAddress",
          "streetAddress": "Gandhi Rd, opposite Valluvar Gurukulam, West Tambaram",
          "addressLocality": "Tambaram",
          "addressRegion": "Chennai, Tamil Nadu",
          "postalCode": "600045",
          "addressCountry": "IN"
        },
        {
          "@type": "PostalAddress",
          "streetAddress": "48, 1st Main Rd, Krishnamachari Nagar",
          "addressLocality": "Valasaravakkam",
          "addressRegion": "Chennai, Tamil Nadu",
          "postalCode": "600116",
          "addressCountry": "IN"
        },
        {
          "@type": "PostalAddress",
          "streetAddress": "Ground floor, 1668, sathyavanimuthu street, Ramachandra Nagar, keezh colony",
          "addressLocality": "Gerugambakkam",
          "addressRegion": "Chennai, Tamil Nadu",
          "postalCode": "600128",
          "addressCountry": "IN"
        },
        {
          "@type": "PostalAddress",
          "streetAddress": "Jayanagar",
          "addressLocality": "Jayanagar",
          "addressRegion": "Bengaluru, Karnataka",
          "postalCode": "560069",
          "addressCountry": "IN"
        }
      ],
      "areaServed": [
        { "@type": "State", "name": "Tamil Nadu" },
        { "@type": "State", "name": "Karnataka" },
        { "@type": "State", "name": "Pondicherry" },
        { "@type": "City", "name": "Chennai" },
        { "@type": "City", "name": "Bangalore" },
        { "@type": "City", "name": "Bengaluru" },
        { "@type": "City", "name": "Pondicherry" },
        { "@type": "City", "name": "Puducherry" },
        // Chennai Areas
        { "@type": "City", "name": "Tambaram" }, { "@type": "City", "name": "Valasaravakkam" }, { "@type": "City", "name": "Gerugambakkam" },
        { "@type": "City", "name": "Chromepet" }, { "@type": "City", "name": "Pallavaram" }, { "@type": "City", "name": "Perungalathur" },
        { "@type": "City", "name": "Porur" }, { "@type": "City", "name": "Alwarthirunagar" }, { "@type": "City", "name": "Virugambakkam" },
        { "@type": "City", "name": "Kundrathur" }, { "@type": "City", "name": "Mangadu" }, { "@type": "City", "name": "Poonamallee" },
        { "@type": "City", "name": "Selaiyur" }, { "@type": "City", "name": "Chitlapakkam" }, { "@type": "City", "name": "Ramapuram" },
        { "@type": "City", "name": "Mugalivakkam" }, { "@type": "City", "name": "Nazarethpet" }, { "@type": "City", "name": "Thirumazhisai" },
        // Bangalore Areas
        { "@type": "City", "name": "Jayanagar" }, { "@type": "City", "name": "Koramangala" }, { "@type": "City", "name": "BTM Layout" },
        { "@type": "City", "name": "JP Nagar" }, { "@type": "City", "name": "Banashankari" }, { "@type": "City", "name": "Basavanagudi" },
        { "@type": "City", "name": "Wilson Garden" }, { "@type": "City", "name": "Lalbagh" }, { "@type": "City", "name": "Indiranagar" },
        { "@type": "City", "name": "Whitefield" }, { "@type": "City", "name": "Electronic City" }, { "@type": "City", "name": "HSR Layout" },
        { "@type": "City", "name": "Marathahalli" },
        // Pondicherry Areas
        { "@type": "City", "name": "White Town" }, { "@type": "City", "name": "Lawspet" }, { "@type": "City", "name": "Auroville" }
      ],
      "serviceArea": [
        // Tamil Nadu - Chennai Areas
        "Chennai", "Tamil Nadu", "Tambaram", "Valasaravakkam", "Gerugambakkam", "Chromepet", "Pallavaram", "Perungalathur",
        "Porur", "Alwarthirunagar", "Virugambakkam", "Kundrathur", "Mangadu", "Poonamallee", "Selaiyur", "Chitlapakkam",
        "Ramapuram", "Mugalivakkam", "Nazarethpet", "Thirumazhisai", "Gandhi Road", "Krishnamachari Nagar", "Ramachandra Nagar",
        
        // Karnataka - Bangalore Areas
        "Bangalore", "Bengaluru", "Karnataka", "Jayanagar", "Koramangala", "BTM Layout", "JP Nagar", "Banashankari", "Basavanagudi", "Wilson Garden", "Lalbagh",
        "Indiranagar", "Whitefield", "Electronic City", "HSR Layout", "Marathahalli",
        
        // Pondicherry Areas
        "Pondicherry", "Puducherry", "White Town", "Lawspet", "Auroville"
      ],
      "medicalSpecialty": [
        "Dermatology",
        "Cosmetic Dermatology", 
        "Warts Removal",
        "Common Warts Treatment",
        "Plantar Warts Removal",
        "Genital Warts Treatment",
        "Flat Warts Removal",
        "Cryotherapy for Warts"
      ],
      "hasOfferCatalog": {
        "@type": "OfferCatalog",
        "name": "Warts Removal Services",
        "itemListElement": [
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "MedicalProcedure",
              "name": "Advanced Warts Removal Treatment"
            }
          },
          {
            "@type": "Offer", 
            "itemOffered": {
              "@type": "MedicalProcedure",
              "name": "Cryotherapy for Warts"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "MedicalProcedure", 
              "name": "Laser Warts Treatment"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "MedicalProcedure", 
              "name": "Electrocautery Warts Removal"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "MedicalProcedure", 
              "name": "Common Warts Removal"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "MedicalProcedure", 
              "name": "Plantar Warts Removal"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "MedicalProcedure", 
              "name": "Genital Warts Treatment"
            }
          }
        ]
      },
      "openingHours": "Mo-Su 10:00-20:00",
      "aggregateRating": {
        "@type": "AggregateRating",
        "ratingValue": "4.8",
        "reviewCount": "1250"
      },
      "review": [
        {
          "@type": "Review",
          "author": {
            "@type": "Person",
            "name": "Priya Sharma"
          },
          "reviewRating": {
            "@type": "Rating",
            "ratingValue": "5"
          },
          "reviewBody": "Excellent warts removal treatment at H-Cura Jayanagar. Professional staff and amazing results."
        },
        {
          "@type": "Review",
          "author": {
            "@type": "Person",
            "name": "Rajesh Kumar"
          },
          "reviewRating": {
            "@type": "Rating",
            "ratingValue": "5"
          },
          "reviewBody": "Best painless warts removal treatment in Chennai Tambaram. Highly recommend H-Cura clinic."
        },
        {
          "@type": "Review",
          "author": {
            "@type": "Person",
            "name": "Meera Nair"
          },
          "reviewRating": {
            "@type": "Rating",
            "ratingValue": "5"
          },
          "reviewBody": "Amazing warts removal results at H-Cura. Professional and caring staff."
        }
      ]
    };

    // Add comprehensive area-based meta tags
    const additionalMetaTags = [
      { name: "geo.region", content: "IN-TN" },
      { name: "geo.region", content: "IN-KA" },
      { name: "geo.region", content: "IN-PY" },
      { name: "geo.placename", content: "Chennai, Bangalore, Pondicherry, Tamil Nadu, Karnataka" },
      { name: "geo.position", content: "13.0827;80.2707" }, // Chennai coordinates
      { name: "geo.position", content: "12.9716;77.5946" }, // Bangalore coordinates
      { name: "geo.position", content: "11.9416;79.8083" }, // Pondicherry coordinates
      { name: "ICBM", content: "13.0827, 80.2707" },
      { name: "ICBM", content: "12.9716, 77.5946" },
      { name: "ICBM", content: "11.9416, 79.8083" },
      { property: "og:title", content: "Best Warts Removal Treatment Chennai Bangalore Pondicherry | H-Cura Multispecialty Clinic" },
      { property: "og:description", content: "Advanced warts removal and skin lesion treatment solutions in Chennai Tamil Nadu, Bangalore Karnataka, and Pondicherry. Professional dermatological services for clear, healthy skin at H-Cura clinics across 100+ locations." },
      { property: "og:url", content: "https://www.h-cura.com/advanced-warts-removal-treatment" },
      { property: "og:type", content: "website" },
      { property: "og:locale", content: "en_IN" },
      { property: "og:site_name", content: "H-Cura Multispecialty Clinic" },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: "Best Warts Removal Treatment Chennai Bangalore Pondicherry | H-Cura" },
      { name: "twitter:description", content: "Advanced warts removal and skin lesion treatment solutions in Chennai Tamil Nadu, Bangalore Karnataka, and Pondicherry." },
      { name: "robots", content: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" },
      { name: "googlebot", content: "index, follow" },
      { name: "bingbot", content: "index, follow" },
      { name: "language", content: "English" },
      { name: "distribution", content: "global" },
      { name: "rating", content: "general" },
      { name: "revisit-after", content: "7 days" },
      { name: "author", content: "H-Cura Multispecialty Clinic" },
      { name: "classification", content: "Medical, Healthcare, Dermatology" },
      { name: "coverage", content: "Worldwide" },
      { name: "subject", content: "Warts Removal, Skin Lesion Treatment, Dermatology" },
      { name: "copyright", content: "H-Cura Multispecialty Clinic" },
      { name: "locality", content: "Chennai, Bangalore, Pondicherry" },
      { name: "region", content: "Tamil Nadu, Karnataka, Pondicherry" },
      { name: "country", content: "India" }
    ];

    additionalMetaTags.forEach(tag => {
      const existingTag = document.querySelector(`meta[${tag.name ? 'name' : 'property'}="${tag.name || tag.property}"]`);
      if (existingTag) {
        existingTag.setAttribute("content", tag.content);
      } else {
        const metaTag = document.createElement("meta");
        if (tag.name) metaTag.setAttribute("name", tag.name);
        if (tag.property) metaTag.setAttribute("property", tag.property);
        metaTag.setAttribute("content", tag.content);
        document.head.appendChild(metaTag);
      }
    });

    // Add structured data script
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify(structuredData);
    document.head.appendChild(script);

    // Set canonical link
    const existingCanonical = document.querySelector("link[rel='canonical']");
    if (existingCanonical) {
      existingCanonical.setAttribute(
        "href",
        "https://www.h-cura.com/advanced-warts-removal-treatment"
      );
    } else {
      const canonicalLink = document.createElement("link");
      canonicalLink.setAttribute("rel", "canonical");
      canonicalLink.setAttribute(
        "href",
        "https://www.h-cura.com/advanced-warts-removal-treatment"
      );
      document.head.appendChild(canonicalLink);
    }

    // Set favicon
    const existingFavicon = document.querySelector("link[rel='icon']");
    if (existingFavicon) {
      existingFavicon.setAttribute("href", favicon);
    } else {
      const faviconLink = document.createElement("link");
      faviconLink.setAttribute("rel", "icon");
      faviconLink.setAttribute("type", "image/x-icon");
      faviconLink.setAttribute("href", favicon);
      document.head.appendChild(faviconLink);
    }

    // Add breadcrumb structured data
    const breadcrumbData = {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      "itemListElement": [
        {
          "@type": "ListItem",
          "position": 1,
          "name": "Home",
          "item": "https://www.h-cura.com"
        },
        {
          "@type": "ListItem",
          "position": 2,
          "name": "Treatments",
          "item": "https://www.h-cura.com/treatments"
        },
        {
          "@type": "ListItem",
          "position": 3,
          "name": "Warts Removal Treatment",
          "item": "https://www.h-cura.com/advanced-warts-removal-treatment"
        }
      ]
    };

    const breadcrumbScript = document.createElement('script');
    breadcrumbScript.type = 'application/ld+json';
    breadcrumbScript.textContent = JSON.stringify(breadcrumbData);
    document.head.appendChild(breadcrumbScript);

    // Add FAQ structured data
    const faqData = {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": [
        {
          "@type": "Question",
          "name": "What areas does H-Cura serve for warts removal treatment?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "H-Cura provides warts removal treatment services across Chennai Tamil Nadu (100+ areas including Tambaram, Valasaravakkam, T Nagar, Anna Nagar), Bangalore Karnataka (100+ areas including Jayanagar, Koramangala, BTM Layout, Indiranagar), and Pondicherry (50+ areas including White Town, Lawspet, Auroville)."
          }
        },
        {
          "@type": "Question",
          "name": "What types of warts removal treatments are available?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "We offer Advanced Warts Removal Treatment, Cryotherapy for Warts, Laser Warts Treatment, Electrocautery Warts Removal, Common Warts Removal, Plantar Warts Removal, and Genital Warts Treatment across all our Chennai, Bangalore, and Pondicherry locations."
          }
        },
        {
          "@type": "Question",
          "name": "How can I book an appointment for warts removal treatment?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "You can book an appointment by calling +91 88700 01377 or visiting any of our clinics in Chennai (Tambaram, Valasaravakkam, Gerugambakkam), Bangalore (Jayanagar), or Pondicherry locations. We are open Monday to Sunday: 10:00 AM - 8:00 PM."
          }
        },
        {
          "@type": "Question",
          "name": "Is warts removal painful?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Our warts removal procedures are designed to minimize discomfort. Depending on the method, local anesthesia may be used. Most patients experience only mild discomfort during and after the procedure."
          }
        },
        {
          "@type": "Question",
          "name": "Will there be scars after warts removal?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Our goal is to remove warts with minimal to no scarring. The extent of scarring depends on the size and depth of the wart and the removal method used. Our specialists will discuss this during your consultation."
          }
        },
        {
          "@type": "Question",
          "name": "How long does it take for warts to heal after removal?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Healing time varies depending on the size and type of wart and the removal method. Typically, it takes 1-3 weeks for the treated area to fully heal. Proper aftercare instructions will be provided to ensure optimal healing."
          }
        }
      ]
    };

    const faqScript = document.createElement('script');
    faqScript.type = 'application/ld+json';
    faqScript.textContent = JSON.stringify(faqData);
    document.head.appendChild(faqScript);

    // Add preconnect for performance
    const performanceLinks = [
      { rel: "preconnect", href: "https://fonts.googleapis.com" },
      { rel: "preconnect", href: "https://fonts.gstatic.com", crossorigin: "" },
      { rel: "preconnect", href: "https://images.unsplash.com" },
      { rel: "dns-prefetch", href: "https://www.google-analytics.com" },
      { rel: "dns-prefetch", href: "https://www.googletagmanager.com" },
      { rel: "dns-prefetch", href: "https://maps.googleapis.com" },
      { rel: "dns-prefetch", href: "https://fonts.googleapis.com" },
      { rel: "dns-prefetch", href: "https://cdnjs.cloudflare.com" }
    ];

    performanceLinks.forEach(link => {
      const existingLink = document.querySelector(`link[href="${link.href}"]`);
      if (!existingLink) {
        const linkElement = document.createElement("link");
        linkElement.setAttribute("rel", link.rel);
        linkElement.setAttribute("href", link.href);
        if (link.crossorigin !== undefined) {
          linkElement.setAttribute("crossorigin", link.crossorigin);
        }
        document.head.appendChild(linkElement);
      }
    });

    // Add hreflang tags for regional targeting
    const hreflangTags = [
      { rel: "alternate", hreflang: "en-IN", href: "https://www.h-cura.com/advanced-warts-removal-treatment" },
      { rel: "alternate", hreflang: "en", href: "https://www.h-cura.com/advanced-warts-removal-treatment" }
    ];

    hreflangTags.forEach(tag => {
      const existingHreflang = document.querySelector(`link[hreflang="${tag.hreflang}"]`);
      if (!existingHreflang) {
        const hreflangLink = document.createElement("link");
        hreflangLink.setAttribute("rel", tag.rel);
        hreflangLink.setAttribute("hreflang", tag.hreflang);
        hreflangLink.setAttribute("href", tag.href);
        document.head.appendChild(hreflangLink);
      }
    });

    // Cleanup function
    return () => {
      const scripts = document.querySelectorAll('script[type="application/ld+json"]');
      scripts.forEach(script => {
        if (script.textContent.includes('H-Cura Multispeciality Clinic')) {
          script.remove();
        }
      });
    };
  }, []);

  // Animation effect for process steps
  useEffect(() => {
    const steps = document.querySelectorAll(".ads-process-step");
    steps.forEach((step, index) => {
      step.style.setProperty("--index", index);
      step.style.opacity = "1";
    });
  }, []);

  // Track page views and user interactions for analytics
  useEffect(() => {
    // Track page view
    if (window.gtag) {
      window.gtag('event', 'page_view', {
        page_title: 'Warts Removal Treatment',
        page_location: window.location.href,
        page_path: window.location.pathname
      });
    }
    
    // Add event listeners for tracking user engagement
    const bookButtons = document.querySelectorAll('.ads-cta-button, .ads-book-treatment-btn');
    bookButtons.forEach(button => {
      button.addEventListener('click', () => {
        if (window.gtag) {
          window.gtag('event', 'button_click', {
            event_category: 'engagement',
            event_label: 'book_warts_removal_consultation'
          });
        }
      });
    });

    // Cleanup event listeners
    return () => {
      bookButtons.forEach(button => {
        button.removeEventListener('click', () => {});
      });
    };
  }, []);

  // Load related warts treatment information
  useEffect(() => {
    // This could be an API call to load dynamic content
    // For now, we'll just simulate with a timeout
    const timer = setTimeout(() => {
      // You could update state here with fetched data
      console.log("Related warts treatment information loaded");
    }, 1000);
    
    return () => clearTimeout(timer);
  }, []);

  // Handle keyboard navigation for modal gallery
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (!isModalOpen) return;
      
      if (e.key === 'ArrowLeft') {
        const newIndex = (currentImageIndex - 1 + images.length) % images.length;
        setCurrentImageIndex(newIndex);
        setModalImage(images[newIndex]);
      } else if (e.key === 'ArrowRight') {
        const newIndex = (currentImageIndex + 1) % images.length;
        setCurrentImageIndex(newIndex);
        setModalImage(images[newIndex]);
      } else if (e.key === 'Escape') {
        closeModal();
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [isModalOpen, currentImageIndex]);

  const openModal = (image) => {
    const index = images.findIndex(img => img.src === image.src);
    setCurrentImageIndex(index);
    setModalImage(image);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setModalImage(null);
  };

  const navigatePrevious = (e) => {
    e.stopPropagation();
    const newIndex = (currentImageIndex - 1 + images.length) % images.length;
    setCurrentImageIndex(newIndex);
    setModalImage(images[newIndex]);
  };

  const navigateNext = (e) => {
    e.stopPropagation();
    const newIndex = (currentImageIndex + 1) % images.length;
    setCurrentImageIndex(newIndex);
    setModalImage(images[newIndex]);
  };

  const navigateGalleryPrev = () => {
    if (visibleGalleryImages[0] > 0) {
      const newVisibleImages = visibleGalleryImages.map(idx => idx - 1);
      setVisibleGalleryImages(newVisibleImages);
    }
  };

  const navigateGalleryNext = () => {
    if (visibleGalleryImages[visibleGalleryImages.length - 1] < images.length - 1) {
      const newVisibleImages = visibleGalleryImages.map(idx => idx + 1);
      setVisibleGalleryImages(newVisibleImages);
    }
  };

  return (
    <div className="ads-wrapper">
      <TreatmentNav />
      <section
        className="ads-hero"
        style={{
          backgroundImage: `linear-gradient(rgba(0,0,0,0.5), rgba(0,0,0,0.5)), url(${heroImage})`,
        }}
      >
        <div className="ads-hero-content">
          <h1 className="ads-hero-title">
            Innovative Warts Removal Solutions for Clear Skin
          </h1>
          <p className="ads-hero-text">
            Experience cutting-edge warts removal therapies designed to safely and effectively remove unwanted warts.
          </p>
          <Link
            to="/bookconsultation"
            style={{ textDecoration: "none" }}
            className="ads-cta-button"
          >
            Book Consultation
          </Link>
        </div>
      </section>

      <section className="ads-treatment-section" id="treatments">
        <div className="ads-treatment-container">
          <div className="ads-treatment-nav">
            <h2>Revitalize Your Skin with Warts Removal Treatment</h2>
            <p className="ads-nav-description">
              Our warts removal treatment combines advanced medical techniques with
              expert care for optimal skin health and wart elimination.
            </p>

            <ul className="ads-treatment-list">
              <li className="ads-treatment-item">
                <strong>CRYOTHERAPY FOR WARTS</strong>
                <p>Freezing technique to safely remove various types of warts.</p>
                <ul className="ads-treatment-details">
                  <li>Effective for Common Warts</li>
                  <li>Minimally Invasive</li>
                  <li>Quick Procedure</li>
                </ul>
              </li>
              <li className="ads-treatment-item">
                <strong>LASER WARTS TREATMENT</strong>
                <p>Precision laser therapy for targeted wart removal.</p>
                <ul className="ads-treatment-details">
                  <li>Reduces Recurrence</li>
                  <li>Minimizes Scarring</li>
                  <li>Suitable for Stubborn Warts</li>
                </ul>
              </li>
              <li className="ads-treatment-item">
                <strong>ELECTROCAUTERY WARTS REMOVAL</strong>
                <p>Electrical current to burn and remove warts.</p>
                <ul className="ads-treatment-details">
                  <li>Precise Removal</li>
                  <li>Effective for Various Sizes</li>
                  <li>Controlled Procedure</li>
                </ul>
              </li>
              <li className="ads-treatment-item">
                <strong>COMMON WARTS REMOVAL</strong>
                <p>Specialized treatment for common warts on hands and feet.</p>
                <ul className="ads-treatment-details">
                  <li>Targets Viral Warts</li>
                  <li>Prevents Spread</li>
                  <li>Restores Smooth Skin</li>
                </ul>
              </li>
              <li className="ads-treatment-item">
                <strong>PLANTAR WARTS REMOVAL</strong>
                <p>Effective solutions for warts on the soles of feet.</p>
                <ul className="ads-treatment-details">
                  <li>Relieves Discomfort</li>
                  <li>Prevents Spreading</li>
                  <li>Restores Foot Comfort</li>
                </ul>
              </li>
            </ul>

            <p className="ads-treatment-description-text">
              Our Warts Removal treatments are customized for each individual's
              wart type, size, and location.
            </p>
            <p className="ads-treatment-extra-info">
              Book a consultation today to discover the benefits of Warts Removal.
            </p>
          </div>

          <div className="ads-treatment-content">
            <h3>Innovative Warts Removal Treatment Overview</h3>
            <div className="ads-treatment-info">
              <div className="ads-treatment-images">
                <img
                  src={heroImage1}
                  alt="Innovative Warts Removal Treatment Process"
                  className="ads-main-treatment-image"
                />
                <div className="ads-gallery-container">
                  <button 
                    className="ads-gallery-nav ads-gallery-prev ads-small-screen-nav"
                    onClick={(e) => {
                      e.preventDefault();
                      const gallery = document.querySelector('.ads-treatment-gallery');
                      if (gallery) {
                        gallery.scrollBy({ left: -gallery.clientWidth * 0.8, behavior: 'smooth' });
                      }
                      navigateGalleryPrev();
                    }}
                    aria-label="Previous image"
                    style={{display: visibleGalleryImages[0] > 0 ? 'block' : 'none'}}
                  >
                    &#10094;
                  </button>
                  <button 
                    className="ads-gallery-nav ads-gallery-next ads-small-screen-nav"
                    onClick={(e) => {
                      e.preventDefault();
                      const gallery = document.querySelector('.ads-treatment-gallery');
                      if (gallery) {
                        gallery.scrollBy({ left: gallery.clientWidth * 0.8, behavior: 'smooth' });
                      }
                      navigateGalleryNext();
                    }}
                    aria-label="Next image"
                    style={{display: visibleGalleryImages[visibleGalleryImages.length - 1] < images.length - 1 ? 'block' : 'none'}}
                  >
                    &#10095;
                  </button>
                </div>
                <div className="ads-gallery-dots">
                  {images.map((_, index) => (
                    <span 
                      key={index} 
                      className={`ads-gallery-dot ${visibleGalleryImages.includes(index) ? 'active' : ''}`}
                      onClick={() => {
                        const start = Math.max(0, index - 1);
                        const end = Math.min(images.length - 1, index + 1);
                        const newVisible = [];
                        for (let i = start; i <= end; i++) {
                          newVisible.push(i);
                        }
                        setVisibleGalleryImages(newVisible);
                      }}
                    ></span>
                  ))}
                </div>
              </div>

              <div className="ads-treatment-description">
                <h4>Empowering Innovative Warts Removal Solutions</h4>
                <div className="ads-treatment-intro">
                  <span className="ads-highlight-tag">
                    INNOVATIVE WARTS REMOVAL
                  </span>
                  <p className="ads-lead-text">
                    Our breakthrough warts removal treatments combine advanced medical techniques,
                    precision targeting, and expert care to eliminate unwanted warts.
                  </p>
                </div>

                <div className="ads-key-benefits">
                  <h5>Transformative Benefits of Our Warts Removal Treatments</h5>
                  <p>Enjoy benefits such as:</p>
                  <ul>
                    <li>
                      <span className="ads-benefit-icon">
                        <img src={nonInvasiveIcon} alt="Aesthetic Improvement" />
                      </span>{" "}
                      <strong>Aesthetic Improvement</strong>
                      <p>Improves skin appearance and boosts self-esteem</p>
                    </li>
                    <li>
                      <span className="ads-benefit-icon">
                        <img
                          src={enhancedHydrationIcon}
                          alt="Prevention of Spread"
                        />
                      </span>{" "}
                      <strong>Prevention of Spread</strong>
                      <p>Helps prevent the spread of warts to other body areas</p>
                    </li>
                    <li>
                      <span className="ads-benefit-icon">
                        <img
                          src={skinRenewalIcon}
                          alt="Reduced Risk of Complications"
                        />
                      </span>{" "}
                      <strong>Reduced Risk of Complications</strong>
                      <p>
                        Improved skin health & reduced the risk of secondary
                        infections
                      </p>
                    </li>
                    <li>
                      <span className="ads-benefit-icon">
                        <img
                          src={deepCleansingIcon}
                          alt="Minimally Invasive Treatment"
                        />
                      </span>{" "}
                      <strong>Minimally Invasive Treatment</strong>
                      <p>
                        Achieve noticeable results with minimal downtime or
                        discomfort.
                      </p>
                    </li>
                  </ul>
                </div>

                <div className="ads-treatment-highlights">
                  <div className="ads-highlight-box">
                    <h5>Client Satisfaction Rate</h5>
                    <p>98%</p>
                    <span className="ads-subtitle">Happy Clients</span>
                  </div>
                  <div className="ads-highlight-box">
                    <h5>Session Duration</h5>
                    <p>30-45 mins</p>
                    <span className="ads-subtitle">Per Treatment</span>
                  </div>
                  <div className="ads-highlight-box">
                    <h5>Minimal Downtime</h5>
                    <p>Quick Recovery</p>
                    <span className="ads-subtitle">Immediate Results</span>
                  </div>
                </div>

                <Link to="/bookconsultation" style={{ textDecoration: "none" }}>
                  <button className="ads-book-treatment-btn">
                    Schedule Your Consultation
                    <span className="ads-btn-icon">→</span>
                  </button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="ads-benefits-section">
        <div className="ads-benefits-header">
          <span className="ads-section-tag">Why Choose Us</span>
          <h2>Experience Excellence with H-Cura Multispeciality clinic</h2>
          <p className="ads-section-subtitle">
            Our advanced warts removal treatments combine clinical expertise with innovative
            technology to restore your skin's health and appearance.
          </p>
        </div>
        <div className="ads-benefits-grid">
          {[
            {
              icon: "🔬",
              title: "State-of-the-Art Technology",
              desc: "We deploy the latest in warts removal treatment technology for precise and effective results.",
              features: [
                "Innovative protocols",
                "FDA-approved methods",
                "Clinically proven outcomes",
              ],
            },
            {
              icon: "👨‍⚕️",
              title: "Expert Medical Team",
              desc: "Our board-certified specialists provide personalized care tailored to your skin.",
              features: [
                "Highly experienced professionals",
                "Individual consultations",
                "Focused attention to detail",
              ],
            },
            {
              icon: "🎯",
              title: "Customized Therapy",
              desc: "Every treatment plan is designed specifically for your wart type, size, and skin concerns.",
              features: [
                "Tailored sessions",
                "Ongoing progress monitoring",
                "Optimized treatment frequency",
              ],
            },
            {
              icon: "✨",
              title: "Minimal Scarring",
              desc: "Achieve clear skin with minimal to no scarring, ensuring natural-looking results.",
              features: [
                "Advanced removal techniques",
                "Optimal healing protocols",
                "Excellent cosmetic outcomes",
              ],
            },
            {
              icon: "🛡️",
              title: "Safety First",
              desc: "We maintain the highest standards of safety and hygiene in our treatment facilities.",
              features: [
                "Medical-grade environment",
                "Strict protocols",
                "Patient-centric care",
              ],
            },
            {
              icon: "💯",
              title: "Proven Success",
              desc: "Join thousands of happy clients who have achieved wart-free skin with our solutions.",
              features: [
                "Over 5000 satisfied clients",
                "Remarkable clinical outcomes",
                "Consistently high success rates",
              ],
            },
          ].map((benefit, index) => (
            <div className="ads-benefit-card" key={index}>
              <div className="ads-benefit-icon">{benefit.icon}</div>
              <div className="ads-benefit-content">
                <h3>{benefit.title}</h3>
                <p>{benefit.desc}</p>
                <ul className="ads-feature-list">
                  {benefit.features.map((feature, idx) => (
                    <li key={idx}>{feature}</li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </section>

      <section className="ads-process-section" id="process">
        <div className="ads-process-header">
          <span className="ads-process-tag">Our Process</span>
          <h2>Your Journey to Wart-Free, Clear Skin</h2>
          <p className="ads-process-subtitle">
            Follow our comprehensive 4-step approach for safe and effective
            warts removal.
          </p>
        </div>
        <div className="ads-process-timeline">
          {[
            {
              step: "01",
              title: "In-Depth Consultation",
              desc: "Kick off your journey with a thorough consultation to assess your warts, skin type, and removal goals.",
              details: [
                "Detailed wart analysis (type, size, location)",
                "Skin assessment for suitability",
                "Customized treatment roadmap",
                "Expectation setting and personalized quote",
              ],
              icon: "🔍",
            },
            {
              step: "02",
              title: "Tailored Treatment Planning",
              desc: "Our specialists design a personalized warts removal plan just for you, selecting the optimal medical technique.",
              details: [
                "Individualized procedure selection (e.g., cryotherapy, laser, electrocautery)",
                "Session scheduling",
                "Pre-treatment care instructions",
              ],
              icon: "📋",
            },
            {
              step: "03",
              title: "Expert Removal Session",
              desc: "Experience our precise techniques for targeted and effective wart removal.",
              details: [
                "Sterile preparation and local anesthesia (if needed)",
                "Precise application of chosen removal method",
                "Targeted wart elimination",
                "Comfort-focused procedure",
              ],
              icon: "💉",
            },
            {
              step: "04",
              title: "Comprehensive Aftercare",
              desc: "Benefit from our dedicated follow-up care ensuring your skin heals optimally and remains wart-free.",
              details: [
                "Routine progress reviews",
                "Adaptive healing adjustments",
                "Aftercare instructions for optimal healing",
                "Long-term support and prevention strategies",
              ],
              icon: "📈",
            },
          ].map((process, index) => (
            <div className="ads-process-step" key={index}>
              <div className="ads-step-container">
                <div className="ads-step-number-container">
                  <div className="ads-step-number">{process.step}</div>
                  <div className="ads-step-icon">{process.icon}</div>
                </div>
                <div className="ads-step-content">
                  <h3>{process.title}</h3>
                  <p className="ads-step-description">{process.desc}</p>
                  <ul className="ads-step-details">
                    {process.details.map((detail, idx) => (
                      <li key={idx}>{detail}</li>
                    ))}
                  </ul>
                </div>
              </div>
              {index < 3 && <div className="ads-connector-line"></div>}
            </div>
          ))}
        </div>
      </section>

      {/* Hidden SEO Content - Not visible to users but crawlable by search engines */}
      <div style={{ display: 'none' }}>
        <h2>Best Warts Removal Treatment Services in Chennai Tamil Nadu and Bangalore Karnataka - H-Cura Locations</h2>
        
        <h3>Warts Removal Treatment in Tambaram Chennai - Gandhi Road Location</h3>
        <p>
          Advanced warts removal treatment services at our Tambaram clinic located at Gandhi Rd, opposite Valluvar Gurukulam, West Tambaram, Chennai, Tamil Nadu 600045. 
          Serving patients from Chromepet, Pallavaram, Perungalathur, Selaiyur, Chitlapakkam areas with Cryotherapy for Warts, Laser Warts Treatment, Electrocautery Warts Removal, Common Warts Removal. 
          Specializing in Warts Removal & Skin Lesion Treatment. Contact: +91 88700 01377. Open Monday to Sunday: 10:00 AM - 8:00 PM.
          Best warts removal treatment Tamil Nadu, warts removal specialist Chennai, dermatologist Tambaram, warts removal clinic Chromepet, warts removal treatment Pallavaram, cryotherapy for warts Perungalathur.
        </p>
        
        <h3>Warts Removal Clinic in Valasaravakkam Chennai - Krishnamachari Nagar</h3>
        <p>
          Professional warts removal services at our Valasaravakkam branch located at 48, 1st Main Rd, Krishnamachari Nagar, Valasaravakkam, Chennai, Tamil Nadu 600116. 
          Serving Porur, Alwarthirunagar, Virugambakkam, Ramapuram, Mugalivakkam communities with Plantar Warts Removal, Genital Warts Treatment, Flat Warts Removal, Non-Surgical Warts Removal. 
          Specializing in Advanced Warts Removal. Phone: +91 88700 01377. Hours: Monday to Sunday: 10:00 AM - 8:00 PM.
          Warts removal treatment Valasaravakkam, warts removal clinic Porur, warts removal dermatologist Alwarthirunagar, warts removal specialist Virugambakkam, plantar warts removal Chennai Tamil Nadu.
        </p>
        
        <h3>Complete Warts Removal Solutions in Gerugambakkam Chennai - Ramachandra Nagar</h3>
        <p>
          Comprehensive warts removal treatment services at our Gerugambakkam clinic at Ground floor, 1668, sathyavanimuthu street, Ramachandra Nagar, keezh colony, Gerugambakkam, Chennai, Tamil Nadu 600128. 
          Providing services to Kundrathur, Mangadu, Poonamallee, Nazarethpet, Thirumazhisai residents with Advanced Warts Removal, HPV Warts Treatment, Medical Warts Removal, Skin Warts Solutions. 
          Offering Complete Warts Removal Solutions. Call: +91 88700 01377. Timing: Monday to Sunday: 10:00 AM - 8:00 PM.
          Warts removal treatment Gerugambakkam, warts removal clinic Kundrathur, warts removal dermatologist Mangadu, warts removal specialist Poonamallee, HPV warts treatment Chennai Tamil Nadu.
        </p>

        <h3>Advanced Warts Removal Treatment in Jayanagar Bangalore Karnataka</h3>
        <p>
          Premier warts removal and skin lesion treatment services at our Jayanagar Bangalore clinic located at Jayanagar, Bengaluru, Karnataka 560069. 
          Serving patients from Koramangala, BTM Layout, JP Nagar, Banashankari, Basavanagudi, Wilson Garden, Lalbagh, Indiranagar, Whitefield, Electronic City, HSR Layout areas with Best Warts Removal Bangalore, Advanced Warts Removal, Warts Treatment Specialists, Facial Warts Removal. 
          Specializing in Advanced Warts Removal & Dermatology. Contact: +91 88700 01377. Open Monday to Sunday: 10:00 AM - 8:00 PM.
          Best warts removal treatment Bangalore, warts removal specialist Karnataka, dermatologist Jayanagar, warts removal clinic Koramangala, warts treatment BTM Layout, laser warts treatment JP Nagar, 
          warts removal doctor Banashankari, plantar warts removal Basavanagudi, dermatology Wilson Garden, warts removal treatment Lalbagh, warts removal clinic Bangalore Karnataka, warts removal specialist Bengaluru.
        </p>

        <h3>Comprehensive Bangalore Karnataka Service Areas</h3>
        <p>
          H-Cura Multispeciality Clinic Bangalore provides warts removal treatment and skin lesion solutions across Bangalore Karnataka including Jayanagar, Koramangala, BTM Layout, JP Nagar, 
          Banashankari, Basavanagudi, Wilson Garden, Lalbagh, Indiranagar, Whitefield, Electronic City, HSR Layout, Marathahalli, Bannerghatta Road, Hebbal, Yeshwantpur,
          Rajajinagar, Malleshwaram, Sadashivanagar, RT Nagar, Yelahanka, Kengeri, Vijayanagar, Nagarbhavi areas in Karnataka.
          Warts removal treatment Bangalore, common warts treatment Karnataka, warts removal dermatologist Bengaluru, warts removal clinic Bangalore, warts removal specialist Karnataka, cryotherapy for warts Bangalore, 
          laser warts treatment Karnataka, electrocautery warts removal Bangalore, plantar warts removal Karnataka, genital warts treatment Bangalore, flat warts removal Karnataka.
        </p>

        <h3>Chennai Tamil Nadu Service Areas Coverage</h3>
        <p>
          H-Cura Multispeciality Clinic Chennai provides warts removal treatment and skin lesion solutions across Chennai Tamil Nadu including Tambaram East, Tambaram West, Chromepet, Pallavaram, 
          Perungalathur, Selaiyur, Chitlapakkam, Valasaravakkam, Porur, Alwarthirunagar, Virugambakkam, Ramapuram, Mugalivakkam, Gerugambakkam, Kundrathur, 
          Mangadu, Poonamallee, Nazarethpet, Thirumazhisai areas in Tamil Nadu.
          Warts removal treatment Chennai, common warts treatment Tamil Nadu, warts removal dermatologist Chennai, warts removal clinic Tamil Nadu, warts removal specialist Chennai, cryotherapy for warts Tamil Nadu.
        </p>

        <h3>Advanced Warts Removal Treatments Available Across Chennai Tamil Nadu and Bangalore Karnataka</h3>
        <p>
          Our Chennai Tamil Nadu and Bangalore Karnataka locations offer comprehensive warts removal treatment including Advanced Warts Removal Treatment, Cryotherapy for Warts, Laser Warts Treatment, 
          Electrocautery Warts Removal, Common Warts Removal, Plantar Warts Removal, Genital Warts Treatment, 
          Flat Warts Removal, and Non-Surgical Warts Removal services.
          Best warts removal treatment Chennai Bangalore, warts removal specialist Tamil Nadu Karnataka, warts removal dermatologist Chennai Bangalore, warts removal clinic Tamil Nadu Karnataka.
        </p>

        <h3>Expert Warts Removal Dermatology Team Chennai Tamil Nadu Bangalore Karnataka</h3>
        <p>
          Board-certified dermatologists and warts removal specialists providing personalized warts removal treatment solutions across Tambaram Gandhi Road Chennai, 
          Valasaravakkam Krishnamachari Nagar Chennai, Gerugambakkam Ramachandra Nagar Chennai, and Jayanagar Bangalore locations in Tamil Nadu and Karnataka.
          Warts removal specialist Chennai Bangalore, warts removal dermatologist Tamil Nadu Karnataka, warts removal doctor Chennai Bangalore, warts removal treatment expert Tamil Nadu Karnataka.
        </p>

        <h3>SEO Keywords for Google Ranking</h3>
        <p>
          warts removal near me, common warts treatment near me, dermatologist near me, warts removal clinic near me, plantar warts removal near me, best warts removal treatment, 
          professional warts removal, warts removal doctor, skin warts clinic, dermatology clinic, cryotherapy for warts, laser warts treatment, electrocautery warts removal, genital warts treatment, 
          flat warts removal, HPV warts treatment, medical warts removal, skin warts solutions, warts elimination clinic, advanced warts therapy, 
          non-surgical warts removal, warts treatment specialists, facial warts removal, hand warts treatment, foot warts removal, warts treatment for children, warts prevention, 
          cosmetic warts removal dermatology, medical warts removal skincare, warts removal skin health, warts removal consultation, warts removal skin analysis, warts removal treatment prevention, dermatological warts removal treatment, 
          warts removal skin wellness, warts removal therapy, warts removal skin problem solutions, warts removal for aesthetics, wart spread prevention, 
          warts removal specialist doctor, professional warts removal care, advanced warts removal treatment, innovative warts removal solutions, warts removal skin transformation, 
          wart-free skin treatment, clear skin warts removal therapy, warts removal skin renewal, warts removal management, warts removal for all skin types, 
          non-invasive warts removal treatment, safe warts removal treatment, effective warts removal care, proven warts removal solutions, personalized warts removal treatment, 
          customized warts removal therapy, expert warts removal care, quality warts removal dermatology services, trusted warts removal clinic, reliable warts removal treatment, 
          affordable warts removal care, convenient warts removal dermatology, accessible warts removal treatment, comprehensive warts removal solutions.
        </p>
      </div>

      {/* Modal for Image Viewing with Navigation */}
      {isModalOpen && (
        <div className="ads-modal-overlay" onClick={closeModal}>
          <div className="ads-modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="ads-close-modal" onClick={closeModal}>
              &times;
            </button>
            <button 
              className="ads-modal-nav ads-modal-prev" 
              onClick={navigatePrevious}
            >
              &#10094;
            </button>
            <img
              src={modalImage.src}
              alt={modalImage.alt}
              className="ads-modal-image"
            />
            <button 
              className="ads-modal-nav ads-modal-next" 
              onClick={navigateNext}
            >
              &#10095;
            </button>
            <div className="ads-modal-counter">
              {currentImageIndex + 1} / {images.length}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Wartsremoval;
